<template>
	<div class="rc-aliadoFinanciero">
        <v-container class="rc-padding fluid">
            <v-layout row pb-5 wrap>
                <v-flex lg6 md6 sm12 xs12 class="aliadoFinanciero__img">
                    <v-img lazy src="/images/homeView/AnimCol1.gif" aspect-ratio="1.7" contain style="width:100%;height:100%"></v-img>
                </v-flex>
                <v-flex lg6 md6 sm12 xs12 class="aliadoFinanciero__text">
                    <p class="text__titulo">
                        <a class="rc-gohome">RedCapital </a> tu aliado financiero en el factoring digital
                    </p>
                    <p class="text__parrafo">
                        Unimos a las empresas de todos los tamaños en un ecosistema <br class="aliadoFinanciero__br">
                        tecnológico. Esto permite que tu empresa siempre cuente con flujo de <br class="aliadoFinanciero__br">
                        caja.
                    </p>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
	import { Component, Vue } from "vue-property-decorator";
	
	@Component({
	/* 	props: {
			titulo : String,
			listado : Array
        }, */
	})
	export default class AliadoFinanciero extends Vue {}
</script>

<style lang="scss" scoped>
    .rc-aliadoFinanciero{
        min-height: 800px;
        display: flex;
        flex-wrap: wrap;
        align-content: center;

        .aliadoFinanciero__text{
            display: flex;
            align-self: center;
            justify-content:center;
            flex-flow: column;
            
            .text__titulo{
                font-size: 1.5rem;
                font-weight: 600;
                color: $rc-prim-g2;
                .rc-gohome{
                    color: $rc-prim-n1;
                }
            }
            .text__parrafo{
                font-size: 1rem;
            }
        }
    }

    

	// Breakpoints 
	@each $breakpoint in $breakpoints_screen_text{
		@include breakpoint_media_queries($breakpoint){
			@if $breakpoint == "x-large"{
				.aliadoFinanciero__img{
                    min-height: 600px;
                }
			}@else if $breakpoint == "large"{
                .aliadoFinanciero__img{
                    min-height: 600px;
                }
                .aliadoFinanciero__text{
                    padding-left: 20px;
                }
			}@else if $breakpoint == "medium-to-large"{
                .aliadoFinanciero__img{
                    min-height: 500px;
                }
                .aliadoFinanciero__br{
                    display: none;
                }
                .aliadoFinanciero__text{
                    padding-left: 20px;
                }
			}@else if $breakpoint == "small-to-medium"{
                .aliadoFinanciero__img{
                    min-height: 500px;
                }
                .aliadoFinanciero__br{
                    display: none;
                }
                .text__titulo{
                    text-align: center;
                }
                .text__parrafo{
                    text-align: center;
                }
			}@else if $breakpoint == "small"{
                .aliadoFinanciero__img{
                    min-height: 500px;
                }
                .aliadoFinanciero__br{
                    display: none;
                }
                .text__titulo{
                    text-align: center;
                }
                .text__parrafo{
                    text-align: center;
                }
            }
		}
	}
</style>
